import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SignupRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Navigate to home first, then trigger signup modal
    navigate('/', { replace: true });
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('openAuthModal', { detail: { mode: 'signup' } }));
    }, 500);
  }, [navigate]);

  return null;
};

export default SignupRedirect;
